import {ValidationType} from './ValidationType'

export const MaintenanceRequestsValidation = {
  ID: {
    validationType: ValidationType.TextFreeFormat,
    isRequired: false,
    maxLength: 0,
    maxValue: 0
  },
  AddedDate: {
    validationType: ValidationType.DateTime,
    isRequired: true,
    maxLength: 0,
    maxValue: 0
  },
  Subject: {
    validationType: ValidationType.TextUpperLowerCase,
    isRequired: false,
    maxLength: 100,
    maxValue: 0
  },
  Body: {
    validationType: ValidationType.TextFreeFormat,
    isRequired: false,
    maxLength: 0,
    maxValue: 0
  },
  ContactID: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 10,
    maxValue: 2147483647
  },
  ContactFirstNames: {
    validationType: ValidationType.TextUpperLowerCase,
    isRequired: false,
    maxLength: 30,
    maxValue: 0
  },
  ContactLastName: {
    validationType: ValidationType.TextUpperLowerCase,
    isRequired: false,
    maxLength: 30,
    maxValue: 0
  },
  ContactEmail: {
    validationType: ValidationType.TextFreeFormat,
    isRequired: false,
    maxLength: 50,
    maxValue: 0
  },
  ContactTelephone: {
    validationType: ValidationType.TextUpperLowerCase,
    isRequired: false,
    maxLength: 30,
    maxValue: 0
  },
  PropertyID: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 10,
    maxValue: 2147483647
  },
  PropertyStreet: {
    validationType: ValidationType.TextUpperLowerCase,
    isRequired: false,
    maxLength: 50,
    maxValue: 0
  },
  PropertyPostcode: {
    validationType: ValidationType.TextUpperCase,
    isRequired: false,
    maxLength: 30,
    maxValue: 0
  },
  SiteID: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 10,
    maxValue: 2147483647
  },
  WorkOrderTypeID: {
    validationType: ValidationType.Numeric,
    isRequired: true,
    maxLength: 10,
    maxValue: 2147483647
  },
  Status: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  StatusDate: {
    validationType: ValidationType.DateTime,
    isRequired: true,
    maxLength: 0,
    maxValue: 0
  },
  UserID: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 10,
    maxValue: 2147483647
  },
  Pictures: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 10,
    maxValue: 2147483647
  },
  ExternalID: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 10,
    maxValue: 2147483647
  },
  WorkOrderID: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 10,
    maxValue: 2147483647
  }
};
